import { ACCENTS, useTweaks, type HeroLayout } from "../context/TweaksContext";

const LAYOUTS: { v: HeroLayout; label: string }[] = [
  { v: "split", label: "Split · Poster Right" },
  { v: "center", label: "Center · Poster Behind" },
  { v: "stack", label: "Stacked · Poster Below" },
];

export function TweaksPanel() {
  const { accent, heroLayout, panelVisible, setAccent, setHeroLayout, hidePanel } = useTweaks();
  if (!panelVisible) return null;
  return (
    <div id="tweaks" className="tweaks">
      <div className="tw-head">
        <span>Tweaks</span>
        <button id="tw-close" aria-label="close" onClick={hidePanel}>×</button>
      </div>
      <div className="tw-body">
        <div className="tw-row">
          <label>Accent color</label>
          <div className="tw-swatches" id="tw-accents">
            {ACCENTS.map((a) => (
              <button
                key={a.k}
                title={a.label}
                data-k={a.k}
                className={a.k === accent ? "active" : ""}
                style={{ background: `linear-gradient(135deg, ${a.c1}, ${a.c2})` }}
                onClick={() => setAccent(a.k)}
              />
            ))}
          </div>
        </div>
        <div className="tw-row">
          <label>Hero layout</label>
          <div className="tw-segs" id="tw-layout">
            {LAYOUTS.map((l) => (
              <button
                key={l.v}
                data-v={l.v}
                className={l.v === heroLayout ? "active" : ""}
                onClick={() => setHeroLayout(l.v)}
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
